import axios from 'axios'

const state = { 
	userHashBrowser: 'null',
};

const getters = {
	//getUserHashBrowser: state => { return state.userHashBrowser },
}

const mutations = {
	setUserHashBrowser: (state, value) => {	state.userHashBrowser = value; },
};

const actions = {
	// Reload if user changes
	checkUserHash: ( { commit, state, rootState, rootGetters } ) => {	

		//console.log('checkUserHash');

		axios.get( rootState.apiURL + rootGetters.getLocale + '/userhash',
			{
				userhash: state.userHashBrowser,
			})
    .then( (respuesta) =>{

    	let userHashServer = respuesta.data.data.userhash;

    	//console.log('userHashBrowser = ' + state.userHashBrowser )
    	//console.log('userHashServer = ' + respuesta.data.data.userhash )

    	if( state.userHashBrowser == 'null' && userHashServer != 'null' ){	// User has changed open session in other tab
    		//console.log('reloading page: User has changed open session in other tab')
    		location.reload();
    	}else if(state.userHashBrowser != 'null' && userHashServer == 'null'){  // User session expired or session closed
    		//console.log('reloading page: User session expired or session closed')
    		location.reload();
    	}else if( state.userHashBrowser != 'null' && userHashServer != 'null' && state.userHashBrowser != userHashServer){ // User changed user
    		//console.log('reloading page: User changed user')
    		location.reload();
    	}else{
    		commit('setUserHashBrowser', userHashServer);	// Set user hash
    	}
    })
    .catch( (error) =>{ 
    	alert(error.response.data.status + ' ' + error.response.data.msg);
		});
	},

	// On reload check if user is logged in
	getUserHash ( { commit, state, rootState, rootGetters }, language ){
		return new Promise((resolve, reject) => {
			//console.log('getUserHash');

			//console.log(router.currentRoute)

			axios.get( rootState.apiURL + language + '/userhash',
				{
					userhash: state.userHashBrowser,
				})
			.then( (respuesta) =>{

				let userHashServer = respuesta.data.data.userhash;

				// NEW
				//rootState.username = ( respuesta.data.data.nombreUsuario != 'default' ) ? respuesta.data.data.nombreUsuario : 'default'
				//rootState.userRole = ( respuesta.data.data.user_profile != 'default' ) ? respuesta.data.data.user_profile : 'default'
				//console.log(respuesta.data.data)

				commit('setUsername', respuesta.data.data.nombreUsuario)
				commit('setUserProfile', respuesta.data.data.user_profile)
				commit('setUserHashBrowser', userHashServer);	// Set user hash
				
				if( respuesta.data.data.user_profile != 'default' ){
					commit('setLoggedIn')
					resolve(true)					
				}else{
					commit('setLoggedOut')
					resolve(false)
				}

				//console.log('settingHashBrowser')
				//console.log('userHashBrowser = ' + respuesta.data.data.userhash )			

				//resolve(true)
			})
			.catch( (error) =>{ 
				alert(error.response.data.status + ' ' + error.response.data.msg);
				reject(error)
			});
		})
	},

	get: ( { commit, state, rootState, rootGetters } ) => {	
		return new Promise((resolve, reject) => {
			console.log('get');
			resolve()
		})
	}

};


export default {
	state,
	getters,
	mutations,
	actions
};
